import "./assets/js/nav-pills.js";
import "./assets/scss/argon-dashboard.scss";
import "./assets/scss/custom_styles.scss";

export default {
  install() {},
};
